import { bus } from '../core/event-bus.js';
import { buildSessionReport } from '../core/report-builder.js';

export function initSessionPanel() {
  const timeline = document.getElementById('session-timeline');
  const exportBtn = document.getElementById('session-export-btn');
  const copyBtn = document.getElementById('session-copy-btn');

  exportBtn.addEventListener('click', () => {
    const data = buildSessionReport();
    const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `vast-session-${data.sessionId || Date.now()}.json`;
    a.click();
    URL.revokeObjectURL(url);
  });

  copyBtn.addEventListener('click', () => {
    const data = buildSessionReport();
    navigator.clipboard.writeText(JSON.stringify(data, null, 2)).then(() => {
      copyBtn.textContent = 'Copied!';
      setTimeout(() => { copyBtn.textContent = 'Copy to Clipboard'; }, 2000);
    });
  });

  // Update session view on events
  bus.on('ad:event', () => _renderTimeline(timeline));
  bus.on('state:changed', () => _renderTimeline(timeline));

  bus.on('session:started', () => {
    timeline.innerHTML = '<p class="placeholder-text">Session recording started...</p>';
  });
  bus.on('session:reset', () => {
    timeline.innerHTML = '<p class="placeholder-text">Session data will appear here after an ad loads.</p>';
  });
}

function _renderTimeline(container) {
  const data = buildSessionReport();
  if (!data.events.length) return;

  container.innerHTML = '';

  // Summary section
  const summary = document.createElement('div');
  summary.style.cssText = 'margin-bottom:12px;padding-bottom:8px;border-bottom:1px solid var(--border);';
  summary.innerHTML = `
    <div style="font-weight:600;margin-bottom:4px;color:var(--text-primary);">Session Summary</div>
    <div>Session: <span style="color:var(--accent)">${data.sessionId || 'n/a'}</span></div>
    <div>Status: <span style="color:var(--accent)">${data.lifecycle?.status || 'idle'}</span></div>
    <div>Duration: <span style="color:var(--accent)">${data.lifecycle?.durationMs ?? 0}ms</span></div>
    <div>Environment: <span style="color:var(--accent)">${data.config.environment || 'unknown'}</span></div>
    <div>Source: <span style="color:var(--accent)">${data.config.sourceType || 'tag'}</span> · <span style="color:var(--accent)">${_truncate(data.config.sourceValue || data.config.tag, 60)}</span></div>
    <div>Events: <span style="color:var(--accent)">${data.events.length}</span></div>
    <div>Network requests: <span style="color:var(--accent)">${data.networkLog.length}</span></div>
    <div>State snapshots: <span style="color:var(--accent)">${data.stateSnapshots.length}</span></div>
    <div>Diagnostics: <span style="color:var(--accent)">${(data.diagnostics?.summary?.error || 0) + (data.diagnostics?.summary?.warning || 0)} issue(s)</span></div>
    ${data.errors.length ? `<div style="color:var(--red)">Errors: ${data.errors.length}</div>` : ''}
  `;
  container.appendChild(summary);

  // Event timeline
  const timelineEl = document.createElement('div');
  for (const event of data.events) {
    const row = document.createElement('div');
    row.style.cssText = 'display:flex;gap:8px;padding:1px 0;';
    const time = document.createElement('span');
    time.style.cssText = 'color:var(--text-muted);min-width:60px;';
    time.textContent = `${event.timestamp}ms`;
    const name = document.createElement('span');
    name.style.color = event.data?.category === 'error' ? 'var(--red)' : 'var(--text-primary)';
    name.textContent = event.type;
    row.appendChild(time);
    row.appendChild(name);

    if (event.type === 'aderror' && event.data?.message) {
      const msg = document.createElement('span');
      msg.style.color = 'var(--red)';
      msg.textContent = `[${event.data.code}] ${event.data.message}`;
      row.appendChild(msg);
    }

    timelineEl.appendChild(row);
  }
  container.appendChild(timelineEl);
}

function _truncate(str, len) {
  if (!str) return '';
  return str.length > len ? str.slice(0, len) + '...' : str;
}
